import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { WaiversHelper } from '@features/groups/fee-waivers/_core/helpers';
import { FeeWaiverAuditLogDrawerService } from '@features/groups/fee-waivers/_core/services';
import { FeeWaiver } from '@shared/types/waivers';
import { EllipsisTooltipComponent } from '@ui-kit/miscs';
import { ChipModule } from 'primeng/chip';

@Component({
    selector: 'fee-waiver-tag',
    imports: [ChipModule, NgClass, EllipsisTooltipComponent],
    templateUrl: './fee-waiver-tag.component.html',
    styleUrl: './fee-waiver-tag.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class FeeWaiverTagComponent {
    private feeWaiverAuditLogDrawerService = inject(FeeWaiverAuditLogDrawerService);

    feeWaiver = input.required<FeeWaiver>();

    isRemovable = input<boolean>(false);
    shouldStopPropagation = input<boolean>(false);
    displayInterval = input<boolean>(false);
    size = input<'small' | 'medium' | 'large'>('small');
    enableAuditLog = input<boolean>(true);

    onRemove = output<number>();

    readonly feeWaiverTagColor = computed(() => WaiversHelper.getFeeWaiverTagColor(this.feeWaiver().type));

    readonly sizeClass = computed(() => {
        switch (this.size()) {
            case 'small':
                return 'small-tag';
            case 'medium':
                return 'medium-tag';
            case 'large':
                return 'large-tag';
            default:
                return '';
        }
    });

    handleClickEvent(event: Event) {
        if (this.shouldStopPropagation()) {
            event.stopPropagation();
        }

        if (!this.enableAuditLog()) {
            return;
        }

        this.feeWaiverAuditLogDrawerService.openFeeWaiverAuditLogDrawer(this.feeWaiver().feeWaiverId);
    }
}
